import SearchDocList from './SearchDocList';
import TokenDashBoardDetails from '../TokenDashBoardDetails/tokendashboarddetails';
import AdminAppointment from './AdminAppointment';
import MoveToBilling from './MoveToBilling';
//import Select from 'react-select';
const appcomponents = {
     SearchDocList ,TokenDashBoardDetails,AdminAppointment,MoveToBilling
}

export default appcomponents;
